export default __webpack_public_path__ + "static/media/photo--sm--25.c1b8b662.jpg";